/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import { storage, getJsonFromUrl } from '../../utils'
import { ActionSheet,Button,Toast} from 'react-weui'
import axios from 'axios'

import ChannelFreeChannel from './ChannelFreeChannel';
import ChannelPayChannel from './ChannelPayChannel';
import {renderMoney} from "../../utils";
import {WKPgyCheck} from '../../components/wk'

import {IconFontBox} from '../../components/details'

import '../../styles/root.css'

class ChannelStudentBottom extends Component {
    constructor() {
        super();
        this.onToggleFavourite = this.onToggleFavourite.bind(this);
        this.onOpenLectureChat = this.onOpenLectureChat.bind(this);
        this.onUnFavourite = this.onUnFavourite.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
        this.state = {
            showToast: false,
            autoShow: false,
            menus: [{
                label: '不再收藏',
                onClick: this.onUnFavourite
            }],
            actions: [{
                label: '取消',
                onClick: this.onRequestClose
            }]
        }
    }
    handleLecture() {
        let intoLectureIndex = storage.getItem(`wk-intoclass-${this.props.channel.id}`);
        if(!intoLectureIndex) {
            if(!this.props.intoLecture) {
                this.setState({showToast:true});
                setTimeout(() => this.setState({showToast:false}), 2500)
                return;
            }
            intoLectureIndex = this.props.intoLecture.id
            if(this.props.intoLecture.lecture_mode === 'video' || this.props.intoLecture.lecture_mode === 'audio'){
                window.location =  `/lecture/${intoLectureIndex}`
            }else{
                window.location =  `/classroom/${intoLectureIndex}`
            }
        }else{
            let index = intoLectureIndex.split('-')[0]
            let type = intoLectureIndex.split('-')[1]
            if(type === 'record') {
                window.location =  `/lecture/${index}`
            }else {
                window.location = `/classroom/${index}`
            }
        }

        
    }
    onUnFavourite() {
        const channelId = this.props.channel.id;
        let formData = new FormData();
        formData.append('type', 'channel');
        formData.append('channel_id', channelId);
        axios.post(`/api/favourite/delete`, formData).then((response) => {
            if (response.data.code === 0) {
                this.onRequestClose();
                this.props.dispatch({
                    type: 'CHANNEL_UNSET_FAVOURITE',
                });
                this.context.page.showToast('取消收藏成功');
            }
        })
    }
    onRequestClose() {
        this.setState({autoShow: false})
    }
    onOpenLectureChat() {
        this.props.dispatch({
            type: 'LECTURE_SHOW_CHAT'
        });
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'lecture_asksome'
        })
    }
    onToggleFavourite() {
        const {channel, isFavorited} = this.props;
        let formData = new FormData();
        formData.append('type', 'channel');
        formData.append('channel_id', channel.id);
        if (isFavorited) {
            this.setState({autoShow: true});
        } else {
            axios.post(`/api/favourite/add`, formData).then((response) => {
                if (response.data.code === 0) {
                    this.props.dispatch({
                        type: 'CHANNEL_SET_FAVOURITE',
                    });
                    this.context.page.showToast('收藏成功');
                }
            })
        }
    }

    handleSVipEnter() {
        if (!this.props.role.is_member) {
            location.href = '/supervipintro/open_member?wk_from=channel';
        } else {
            this.props.dispatch({
                type: 'PAY_CHANNEL_MEMBER',
                payload: {
                    params: {
                        product: 'pay_channel_member',
                        channel_id: this.props.channel.id,
                    },
                    success: () => {
                        this.props.dispatch({
                            type: 'PAY_SUCCESS'
                        })
                        window._wk_toast && window._wk_toast.show('已添加到__br我的微课', 'success', 2000)
                        this.props.dispatch({
                            type: 'CHANNEL_SVIP_SUCCESS'
                        })
                    }
                }
            })
        }
    }

    componentWillUnmount() {
        this.svip && clearTimeout(this.svip)
    }

    handlePayChannel() {
        const channelId = this.props.channel.id;

        this.props.dispatch({
            type: 'PAY_CHANNEL',
            payload: {
                params: {
                    product: 'pay_channel',
                    channel_id: channelId,
                    inviter_id:'61221579'
                },
                success: () => {
                    window.location = `/supervipintro/pay_success`;
                }
            }
        })
    }

    handleSubscribePgy() {
        const {channel} = this.props

        WKPgyCheck.subscribe(channel.id, 'channel').then(res => {
            if (res.data.ret === 0) {
                this.context.page.showToast('订阅成功')
                this.props.dispatch({
                    type: 'CHANNEL_SVIP_SUCCESS'
                })
            } else {
                this.context.page.showAlert(res.data.error)
            }
        })
    }

    renderPgyMallBtn() {
        return (
            <div style={{padding: '10px'}}>
                <span onClick={() => {this.handleSubscribePgy()}} style={{
                    height: '42px',
                    background: 'linear-gradient(269deg,rgba(255,63,60,1),rgba(255,115,56,1))',
                    borderRadius: '21px',
                    lineHeight: '42px',
                    fontSize: '16px',
                    color: '#fff',
                    width: '100%',
                    display: 'block',
                    textAlign: 'center',
                }}>会员免费订阅</span>
            </div>
        )
    }

    render() {
        const {channel, channelScribed,isFavorited,role,channel_access} = this.props;
        const {autoShow,menus,actions} = this.state;
        let urlParams = getJsonFromUrl()
        let accessTap = false;
        const access = role.is_liveroom_vip || channel_access
        if(!channel.is_relay){
            if(channel.need_money && access){
                accessTap = true;
            }
        }else{
            if(channel.need_money && channel_access){
                accessTap = true;
            }
        }

        // 蒲公英商城过来的用
        if (urlParams && urlParams.show_subscribe_tabbar && !channel_access) {
            return this.renderPgyMallBtn()
        }

        return (
            <div className={"channel-student-bottom "} style={{display:'flex'}}>
                <Toast show={this.state.showToast} >
                        <img src="https://static-1253442168.image.myqcloud.com/picture/5459246_033f6f23e8b8dcb86d2e6b9d24b68c5f.jpg" />
                            当前专栏尚未开课
                            <br/>
                            点击咨询联系讲师
                        </Toast> 
                    <ActionSheet actions={actions} menus={menus} show={autoShow} onRequestClose={this.onRequestClose}/>
                    <IconFontBox
                        icon={<img src='https://static-1253442168.image.myqcloud.com/picture/6031279_84e3c998d9bd010deb1ab48c74e8eca6.jpg' alt="咨询icon"/>}
                        title='咨询'
                        onClickHandle={this.onOpenLectureChat}
                    />
                    <IconFontBox
                    icon={<img src={isFavorited ? 
                        'https://static-1253442168.image.myqcloud.com/picture/6031279_85feb7d394082d7c025cf67896ba095e.jpg' :
                        'https://static-1253442168.image.myqcloud.com/picture/6031279_2cd90631da64bdafe5c17e0025424806.jpg'} alt="收藏icon"/>}
                    title={isFavorited ? '已收藏' : '收藏'}
                    onClickHandle={this.onToggleFavourite}
                />
                {(channel.is_member_goods && !channel_access && /from_svip_page/.test(window.location.search) && !role.is_liveroom_vip) ?
                    (role.is_member?
                            <div className="channel-pay-channel" style={{width:'100%'}}>
                                <Button className="weui-flex__item flex_3" onClick={() => this.handleSVipEnter()}>会员免费听</Button>
                            </div>
                        :
                        <div className="channel-pay-channel channel-pay-channel-svip" style={{width:'100%'}}>
                            <Button className="weui-flex__item flex_3 original-cost" onClick={() => this.handlePayChannel()}>¥{renderMoney((channel.promoprice && channel.promoprice.price) || channel.money)} 购买</Button>
                            <Button className="weui-flex__item flex_3" onClick={() => this.handleSVipEnter()}>会员免费听</Button>
                        </div>
                    )
                    :
                    (channel.need_money ?
                        (accessTap ?
                            <div className="channel-pay-channel" style={{width:'100%'}}>
                                <Button className="weui-flex__item flex_3" onClick={this.handleLecture.bind(this)}>开始学习</Button>
                            </div>
                            :
                            <ChannelPayChannel />)
                        :
                        (!channelScribed ?
                            <ChannelFreeChannel />
                            :
                            <div className="channel-pay-channel" style={{width:'100%'}}>
                                <Button className="weui-flex__item flex_3" onClick={this.handleLecture.bind(this)}>开始学习</Button>
                            </div>)
                    )
                }
            </div>
        ) 
    }
}

ChannelStudentBottom.contextTypes = {
    page: React.PropTypes.object,
};

export default connect((state) => ({
    channel: state.channel.channel,
    channelScribed: state.channel.channel_access.subscribed,
    isFavorited: state.channel.role.is_favorited,
    channel_access: state.channel.channel_access.granted,
    role:state.channel.role,
    intoLecture: state.channel.lectures[0],
}))(ChannelStudentBottom)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelStudentBottom.js